import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { deleteObject, getDownloadURL, getStorage, ref, uploadBytesResumable } from '@angular/fire/storage';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AlertController, IonicModule } from '@ionic/angular';
import { IBeverage } from 'app/models/beverage';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-image-label',
  templateUrl: './image-label.component.html',
  styleUrls: ['./image-label.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
  ]

})
export class ImageLabelComponent {


  @Input() item!: IBeverage;
  // @Input() uid!: string;
  @Input() barId!: string;
  @Output() softUpdate = new EventEmitter<string>();

  constructor(
    private alertController: AlertController) { }

  fileName!: string;
  fileSize!: number;
  isUploadingImage = false;
  isUploadedImage!: boolean;


  // Upload Task
  task: any; // TODO: AngularFireUploadTask;

  // Progress in percentage
  percentage = signal(0);

  // Display waiting for image
  displayWaitingForImage = signal(false);

  // Snapshot of uploading file
  snapshot!: Observable<any>;

  uploadFile(eventTarget: any) {

    var event = eventTarget.target['files']

    // // The File object
    const file = event?.item(0);

    // // Validation for Images Only
    if (file?.type.split('/')[0] !== 'image') {
      console.error('unsupported file type :( ');
      return;
    }

    this.fileName = file.name;

    // // The storage path
    const path = `${this.barId}/label/${new Date().getTime()}_${file.name}`;

    // // File reference
    const storage = getStorage();
    const fileRef = ref(storage, path);

    // // The main task
    const uploadTask = uploadBytesResumable(fileRef, file);

    uploadTask.on('state_changed', (snapshot) => {
      // Observe state change events such as progress, pause, and resume
      // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
      this.percentage.set((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
      console.info('Upload is ' + this.percentage() + '% done');
      switch (snapshot.state) {
        case 'paused':
          console.info('Upload is paused');
          break;
        case 'running':
          this.displayWaitingForImage.set(true);
          console.info('Upload is running');
          break;
      }
    },
      (error) => {
        console.error('error', error);

        // Handle unsuccessful uploads
      },
      () => {
        // Handle successful uploads on complete
        getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {
          const newFileUrl = this.getNewFileName(downloadURL);

          await this.setImage(newFileUrl);
          this.isUploadingImage = false;
        });
      });

  }


  async confirmDeleteImage() {
    const alert = await this.alertController.create({
      header: 'Delete image',
      message: 'Are you sure you want to delete image?',
      buttons: [{
        text: 'Cancel',
        role: 'cancel',
        cssClass: 'alert-button-cancel'
      }, {
        text: 'Delete',
        cssClass: 'alert-button-delete',
        handler: () => {
          this.deleteImage();
        }
      }]
    });

    await alert.present();

  }

  private async deleteImage() {
    try {
      await this.deleteOldImage(this.item?.image);
    } catch (error) {
      console.error('delete error', error);
    }
    //this.item.backgroundUrl = '';
    this.softUpdateItem('');

  }

  private async setImage(newFileUrl: string) {
    try {
      await this.deleteOldImage(this.item.image);
    } catch (error) {
      console.error('delete error', error);
    }

    this.item = {
      ...this.item,
      image: newFileUrl
    };
    this.isUploadedImage = true;
    while (this.isUploadedImage) {
      try {
        const storage = getStorage();
        const pathReference = ref(storage, newFileUrl);

        await getDownloadURL(pathReference).then(async (downloadURL) => {
          this.item = {
            ...this.item,
            image: newFileUrl
          };
          this.softUpdateItem(downloadURL);
          this.isUploadedImage = false;
          this.displayWaitingForImage.set(false);
        }).catch(async (ex) => {
          await this.delay(500);
          this.displayWaitingForImage.set(true);
          console.error('Image does not exist yet');
        });
      } catch (ex) {
        await this.delay(500);
        this.displayWaitingForImage.set(true);
        console.error('Image does not exist yet2');
      }
    }
  }



  private async deleteOldImage(url: string | undefined) {
    if (url) {
      const storage = getStorage();
      const pathReference = ref(storage, url);
      return await deleteObject(pathReference);
    }
  }

  private getNewFileName(fileName: string) {
    const lastIndex = fileName.lastIndexOf('.');
    return fileName.substring(0, lastIndex) + '_2560x1440' + fileName.substring(lastIndex);
  }


  private delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  private softUpdateItem(item: string) {
    this.softUpdate.emit(item);
  }


}
